import {
    Component,
    Input,
    OnDestroy,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { SelectorComponent } from "@components/selector/selector.component";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { Atgard } from "~app/features/virkeskop/models/atgard-models";
import { VKAtgardMbf } from "~app/features/virkeskop/models/mbf-models";
import { AtgardMbfService } from "~app/features/virkeskop/services/atgard-mbf.service";
import { AtgardMediatorService } from "~app/features/virkeskop/services/atgard-mediator.service";

@Component({
    selector: "rask-markberedningsmetod",
    templateUrl: "./markberedningsmetod.component.html",
    styleUrls: ["./markberedningsmetod.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        SelectorComponent,
        FormsModule
    ]
})

export class MarkberedningsmetodComponent implements OnInit, OnDestroy {
    anmalanMarkberedningsmetod: string;
    @Input() atgardMbf: VKAtgardMbf;
    @Input() readonly = false;

    protected markberedningsalternativ: string[] = [];

    private readonly atgardMbfService = inject(AtgardMbfService);
    private readonly atgardMediatorService = inject(AtgardMediatorService);
    private readonly destroy$ = new Subject<void>();

    private atgard: Atgard;

    metodChanged() {
        if (ObjectUtils.hasValue(this.anmalanMarkberedningsmetod)) {
            this.atgardMbf.anmalanMarkberedningsmetod = this.anmalanMarkberedningsmetod;
            this.atgardMbfService.updateMarkberedningsMetod(this.atgard.guid, this.anmalanMarkberedningsmetod);
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    ngOnInit(): void {
        this.atgardMediatorService.atgard$.pipe(
            takeUntil(this.destroy$)
        ).subscribe(atgard => this.atgard = atgard);

        this.atgardMbfService.getMarkberedningsMetoder().subscribe({
            next: beredningsmetod => {
                this.markberedningsalternativ = beredningsmetod;
                this.anmalanMarkberedningsmetod = this.atgardMbf.anmalanMarkberedningsmetod;
            },
            error: () => {
                this.markberedningsalternativ = [];
            }
        });
    }
}
